import { render } from "./UsersManagement.vue?vue&type=template&id=0584f697&scoped=true"
import script from "./UsersManagement.vue?vue&type=script&lang=js"
export * from "./UsersManagement.vue?vue&type=script&lang=js"

import "./UsersManagement.vue?vue&type=style&index=0&id=0584f697&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0584f697"]])

export default __exports__